var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          style: _vm.modalStyle,
          attrs: {
            title: _vm.title,
            width: _vm.width,
            visible: _vm.visible,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "关闭",
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
                _vm._v("取消"),
              ]),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确认提交")]
              ),
            ],
            1
          ),
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c("a-alert", {
                attrs: {
                  type: "info",
                  "show-icon": "",
                  message: "提交流程",
                  description:
                    "提交后单据将进入多级审批流程，由审批人逐级审批，全部通过后单据自动审核。",
                },
              }),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px", "font-size": "14px" } },
                [_vm._v("单据编号：" + _vm._s(_vm.billNo))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }